<template>
	<div class="personnelManage-body">
        <div class="fx-header">
			<p>员工管理</p>
		</div>
		<Search @getTableData="getTableDataHandle" @getParamsData="getParamsData"></Search>
        <div class="btn-box1">
			<el-button
				type="primary"
				class="search-btn fx-big-btn"
				style="margin-left:0"
				size="small "
				v-if="AuthorityList['01_0004_0002_00']"
				@click='addClick'
				plain>新建
			</el-button>
			<el-button
				type="primary"
				class="search-btn fx-big-btn"
				v-if="AuthorityList['01_0004_0003_00']"
				size="small "
				@click="deleteList"
				plain>删除
			</el-button>
			<el-button
				type="primary"
				class="search-btn fx-big-btn"
				v-if="AuthorityList['01_0004_0004_00']"
				size="small "
				@click="enabled"
				plain>启用
			</el-button>
			<el-button
				type="primary"
				class="search-btn fx-big-btn"
				v-if="AuthorityList['01_0004_0005_00']"
				size="small "
				@click="disabled"
				plain>停用
			</el-button>
			<el-button
				type="primary"
				class="search-btn fx-big-btn"
				v-if="AuthorityList['01_0004_0005_00']"
				size="small "
				@click="multiSet"
				plain>批量设置
			</el-button>
        </div>
		<div class="main-table-box">
			<el-table
			:stripe='true'
			size='mini'
			class="grid-content"
			@row-dblclick='rowClick'
			:data="tableData"
			:height="tableHeight"
			border
			ref='table'
			@select="handleSelectionChange"
			@select-all="handleSelectionChange">
			<el-table-column
			type="selection"
			align="center"
			fixed="left"
			:selectable='selectable'
			width="50">
			</el-table-column>
			<el-table-column
				fixed="left"
				label-class-name = "column-index"
				label="序号"
				type="index"
				width="50"
				align="center">
			</el-table-column>
			<el-table-column
				fixed="left"
				prop="staffName"
				label="员工名称"
				align="center"
				min-width="180">
			</el-table-column>
			<el-table-column
				fixed="left"
				prop="staffNumber"
				label="员工编号"
				align="center"
				min-width="100">
			</el-table-column>
			<el-table-column
				prop="tel"
				label="联系方式"
				align="center"
				min-width="130">
			</el-table-column>
			<el-table-column
				prop="staffDisabled"
				label="员工状态"
				align="center"
				min-width="90">
				<template slot-scope='scope'>
					<span v-if='scope.row.staffDisabled === false' style="color:green">启用</span>
					<span v-if='scope.row.staffDisabled === true' style="color:red">停用</span>
				</template>
			</el-table-column>
			<el-table-column
				prop="roleName"
				label="员工角色"
				align="center"
				min-width="100">
				<template slot-scope="scope">
					<span v-if='scope.row.roleCount > 1'>多角色</span>
					<span v-else>{{scope.row.roleName}}</span>
				</template>
			</el-table-column>
			<el-table-column
				prop="staffDisabled"
				label="员工类型"
				align="center"
				min-width="90">
				<template slot-scope='scope'>
					<span v-if='scope.row.usertype === 0'>内控</span>
					<span v-if='scope.row.usertype === 1'>业务</span>
				</template>
			</el-table-column>
			<el-table-column
				prop="subscriptionSendFlag"
				label="是否接收消息"
				align="center"
				min-width="90">
				<template slot-scope='scope'>
					<span v-if='scope.row.subscriptionSendFlag'>是</span>
					<span v-if='!scope.row.subscriptionSendFlag'>否</span>
				</template>
			</el-table-column>
			<el-table-column
				prop="subordinateNum"
				label="管理下属"
				align="center"
				min-width="90">
				<template slot-scope='scope'>
					<span v-if="scope.row.isAdmin !== 1" @click="subordinateClick(scope.row)" style="color: var(--fx-primary-color);text-decoration: underline;cursor: pointer;">{{scope.row.canManagerUserCount}}人</span>
				</template>
			</el-table-column>
			<el-table-column
				prop="subordinateNum"
				label="管理客户"
				align="center"
				min-width="90">
				<template slot-scope='scope'>
					<span v-if="scope.row.isAdmin !== 1" @click="customerBoxClick(scope.row)" style="color: var(--fx-primary-color);text-decoration: underline;cursor: pointer;">{{scope.row.relAllCustomerFlag === 1 ? '全部客户' : `${scope.row.canManagerCustomerCount}人`}}</span>
				</template>
			</el-table-column>
			<el-table-column
				prop="subordinateNum"
				label="适用门店"
				align="center"
				min-width="90">
				<template slot-scope='scope'>
					<div v-if="scope.row.relAllShopFlag === 1" style="color:var(--fx-primary-color);">全部门店</div>
					<div v-else :title='scope.row.shopNames' style="color:var(--fx-primary-color);cursor: pointer;">{{scope.row.shopCount}}家</div>
				</template>
			</el-table-column>
			<el-table-column label="操作" width="200" align="center">
				<template slot-scope="scope">
					<el-button v-if="AuthorityList['01_0004_0001_00'] || AuthorityList['01_0004_0008_00'] " @click="modifyClick(scope.row)" type='text' size="mini"
					icon="el-icon-search">查看</el-button>
					<el-button @click="deleteClick(scope.row)" v-if="AuthorityList['01_0004_0003_00'] && scope.row.isAdmin !== 1" type='text' size="mini" icon="el-icon-delete">删除</el-button>
				</template>
			</el-table-column>
			</el-table>
		</div>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page.number"
            :page-sizes="[20, 40, 60, 100, 300]"
            :page-size="page.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
        </el-pagination>
        <el-dialog class="detail-dialog-title" top='60px' :close-on-click-modal="false" :visible.sync="addModal" width='700px'>
			<viewModel ref='addModal' :isAdd='isAdd' :isShow='addModal' :addDisable="AuthorityList['01_0004_0002_00']"  :isDisabled="AuthorityList['01_0004_0001_00']" :modifyData='modifyData' :AuthorityList="AuthorityList" @showModal='showModal' v-if="isAdd"></viewModel>
		</el-dialog>
		<el-dialog title='删除失败' class="alert-dialog" top='60px' :close-on-click-modal="false" :visible.sync="alertModal" width='400px'>
			<div style="min-height:100px;max-height:250px;overflow-y:auto">
				<p class="alert-span" v-for='(item,index) in alertList' :key="index">
					{{item}}
				</p>
			</div>
			<el-button class="fx-big-btn" size='mini' style="margin-bottom:10px;margin-top:10px" type="primary" plain @click="alertCancel">确定</el-button>
		</el-dialog>
		<el-dialog :title='staffName + "的邀请码"' top='60px' class="showPicDialog" :close-on-click-modal="false" :visible.sync="isShowPic" :width='picList.length > 6 ? "475px":"460px"'>
			<div class="pic-box">
				<div class="pic-container" v-for="(item,index) in picList" :key="index">
					<div class="pic-div">
						<w-image style="width:100%;height:100%" :src="item.imgUrl"></w-image>
					</div>
					<div class="pic-info">
						{{item.shopName}}
					</div>
					<div class="pic-info">
						邀请码:{{item.invitationCode}}
					</div>
				</div>
			</div>
			<div class="text-box">
				*可右键另存图片
			</div>
			<el-button v-if="showCreatBtn" class="fx-big-btn" size='mini' style="margin-bottom:10px;margin-top:10px" type="primary" plain @click="reloadPicClick">生成二维码</el-button>
			<el-button class="fx-big-btn" size='mini' style="margin-bottom:10px;margin-top:10px" type="primary" plain @click="picCancel">关闭</el-button>
		</el-dialog>
		<el-dialog top='60px' class="subordinateDialog" :close-on-click-modal="false" :visible.sync="showSubordinate" width='800px'>
			<div class="title">
				<div style="display: flex;flex-direction: row;align-items: center;">
					<div class="blue-line"></div>
					{{staffName}}可管理下属员工 <span style="color: red;font-size: 14px;margin-left: 10px;">(共{{staffNum}}人)</span>
				</div>
				<span class="close" @click='closeClick'>
					<i class="el-icon-close"></i>
				</span>
			</div>
			<div class="type-box">
				<el-radio @change='reloadTableData' v-model="type" :label="1">可管理</el-radio>
				<el-radio @change='reloadTableData' v-model="type" :label="0">未管理</el-radio>
			</div>
			<div class="input-box">
				<span>员工名称：</span>
				<el-input
					v-model="userName"
					placeholder="请输入员工名称/员工编号"
					class="name-input"
					size="mini"
					@keyup.enter.native="reloadTableData"
					>
					<i slot="prefix" class="el-input__icon el-icon-search"></i>
				</el-input>
				<el-button size='mini' type="primary" @click='reloadTableData'>查看</el-button>
			</div>
			<div style="height: 300px;margin-top: 10px;">
				<el-table
				:stripe='true'
				ref='table1'
				size='mini'
				class="grid-content"
				:data="tableData1"
				:height="tableHeight"
				border
				@selection-change="handleSelectionChange1">
				<el-table-column
				type="selection"
				align="center"
				:selectable='selectable1'
				width="50">
				</el-table-column>
				<el-table-column
					prop="userName"
					label="员工名称"
					align="center"
					min-width="180">
				</el-table-column>
				<el-table-column
					prop="userNumber"
					label="员工编号"
					align="center"
					min-width="100">
				</el-table-column>
				<el-table-column
					prop="roleName"
					label="员工角色"
					align="center"
					min-width="100">
					<template slot-scope="scope">
						<span v-if='scope.row.roleCount > 1'>多角色</span>
						<span v-else>{{scope.row.roleName}}</span>
					</template>
				</el-table-column>
				<el-table-column
					prop="disabledFlag"
					label="员工状态"
					align="center"
					min-width="90">
					<template slot-scope='scope'>
						<div style="display: flex;flex-direction: row;align-items: center;justify-content: center">
							<div v-if='!scope.row.disabledFlag'  style="width: 5px;height: 5px;margin-right: 5px;border-radius: 50%;background-color: #60C769;"></div>
							<div v-if='scope.row.disabledFlag'  style="width: 5px;height: 5px;margin-right: 5px;border-radius: 50%;background-color: #727A83;"></div>
							<span v-if='!scope.row.disabledFlag' style="color:#333333">启用</span>
							<span v-if='scope.row.disabledFlag' style="color:#727A83">停用</span>
						</div>
					</template>
				</el-table-column>
				<el-table-column
					v-if="type === 0"
					prop="leaderFlag"
					label="上下级关系"
					align="center"
					min-width="100">
					<template slot-scope='scope'>
						<span v-if='scope.row.leaderFlag === 1'>上级</span>
						<span v-else>下级</span>
					</template>
				</el-table-column>
				</el-table>
			</div>
			<div style="width: 100%;height: 60px;margin-bottom: 10px;display: flex;align-items: center;justify-content: flex-end;">
				<el-button @click='closeClick' size='mini'>取消</el-button>
				<el-button @click='bindClick' v-if="type === 0 && AuthorityList['01_0004_0001_00']" size='mini' type="primary">绑定</el-button>
				<el-button  @click='unBindClick' v-if="type === 1 && AuthorityList['01_0004_0001_00']"  size='mini' type="primary">解绑</el-button>
			</div>
		</el-dialog>
		<el-dialog title='管理客户' top='60px' class="customerDialog" :close-on-click-modal="false" :visible.sync="customerBoxDialog" width='800px'>
			<div style="margin: 10px 20px;">
				<div style="display: flex;align-items: center;height: 40px;">
					<div style="width:90px;text-align: right;">
						管理客户：
					</div>
					<el-radio style="height: 20px;line-height: 20px;" v-model="relAllCusFlag" :label="1">全部客户</el-radio>
					<el-radio style="height: 20px;line-height: 20px;" v-model="relAllCusFlag" :label="0">自定义客户</el-radio>
					<div  v-if="relAllCusFlag === 0" @click="customerClick(1)" style="height: 20px;line-height: 20px;margin-left:10px;color:var(--fx-primary-color);cursor: pointer;font-size: 12px;">
						<i style="font-size: 14px;" class="el-icon-circle-plus"></i>
						选择客户
					</div>
				</div>
				<div v-if="relAllCusFlag === 1 || (relAllCusFlag === 0 && cusText)" style="display: flex;align-items: center;min-height: 40px;padding-bottom: 25px;">
					<div style="width:90px;text-align: right;">
						已选：
					</div>
					<div style="width: 100%;text-align: left;">{{relAllCusFlag === 1 ? '全部客户' : cusText}}</div>
				</div>
				<div class="title-btn-box">
					<el-button class="btn" plain type="primary" size='small' @click="saveBatchCus(1)">确认</el-button>
				</div>
			</div>
		</el-dialog>
		<el-dialog title='客户管理' top='60px' class="customerDialog" :close-on-click-modal="false" :visible.sync="customerDialog" width='800px'>
			<bindCustomer
				ref='bindCustomer'
				v-if='customerDialog'
				:customerDialog.sync="customerDialog"
				:isEdit="AuthorityList['01_0004_0001_00']"
				:staffId='staffid'
				:openType='openType'
				@closepage='closeCustomer'
				@reloadCustomer='reloadCustomer'
			>
			</bindCustomer>
		</el-dialog>
		<el-dialog :title="'批量设置 (已选择' + ids.length + '位员工)'" class="dialog-title" :visible.sync="showBatchSetting" width='700px' :close-on-click-modal="false">
			<div class="batchSetBox">
				<div class="input-box">
					<span>字段名：</span>
					<el-select v-model="multiWord" class="filter-input" size='small'>
						<el-option value="0" label="适用门店"></el-option>
						<el-option value="1" label="管理客户"></el-option>
					</el-select>
				</div>
				<div style="margin: 10px 20px;" v-if="multiWord === '0'">
					<div style="display: flex;align-items: center;height: 40px;">
						<div style="width:90px;text-align: right;">
							适用门店：
						</div>
						<el-radio style="height: 20px;line-height: 20px;" v-model="relAllShopFlag" :label="1">全部门店</el-radio>
						<el-radio style="height: 20px;line-height: 20px;" v-model="relAllShopFlag" :label="0">自定义门店</el-radio>
						<div  v-if="relAllShopFlag === 0" @click="bindShopClick" style="height: 20px;line-height: 20px;margin-left:10px;color:var(--fx-primary-color);cursor: pointer;font-size: 12px;">
							<i style="font-size: 14px;" class="el-icon-circle-plus"></i>
							选择门店
						</div>
					</div>
					<div v-if="relAllShopFlag === 1 || (relAllShopFlag === 0 && shopText)" style="display: flex;align-items: center;min-height: 40px;padding-bottom: 25px;">
						<div style="width:90px;text-align: right;">
							已选：
						</div>
						<div style="width: 100%;text-align: left;">{{relAllShopFlag === 1 ? '全部门店' : shopText}}</div>
					</div>
					<div class="title-btn-box">
						<el-button class="btn" plain type="primary" size='small' @click="saveBatchShop">确认</el-button>
					</div>
				</div>
				<div style="margin: 10px 20px;" v-if="multiWord === '1'">
					<div style="display: flex;align-items: center;height: 40px;">
						<div style="width:90px;text-align: right;">
							管理客户：
						</div>
						<el-radio style="height: 20px;line-height: 20px;" v-model="relAllCusFlag" :label="1">全部客户</el-radio>
						<el-radio style="height: 20px;line-height: 20px;" v-model="relAllCusFlag" :label="0">自定义客户</el-radio>
						<div  v-if="relAllCusFlag === 0" @click="customerClick(2)" style="height: 20px;line-height: 20px;margin-left:10px;color:var(--fx-primary-color);cursor: pointer;font-size: 12px;">
							<i style="font-size: 14px;" class="el-icon-circle-plus"></i>
							选择客户
						</div>
					</div>
					<div v-if="relAllCusFlag === 1 || (relAllCusFlag === 0 && cusText)" style="display: flex;align-items: center;min-height: 40px;padding-bottom: 25px;">
						<div style="width:90px;text-align: right;">
							已选：
						</div>
						<div style="width: 100%;text-align: left;">{{relAllCusFlag === 1 ? '全部客户' : cusText}}</div>
					</div>
					<div class="title-btn-box">
						<el-button class="btn" plain type="primary" size='small' @click="saveBatchCus(2)">确认</el-button>
					</div>
				</div>
			</div>
		</el-dialog>
		<el-dialog
			top='100px'
			title="选择适用门店"
			class="dialog-title"
			:visible.sync="shopDialog"
			:append-to-body="true"
			width="780px"
			:close-on-click-modal="false">
			<div>
				<bindShop v-if="shopDialog" :customerDialog.sync='shopDialog' :chooseData1='chooseShop' @reloadCus='reloadShop'></bindShop>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import Search from '@/components/personnelManage/Search.vue'
import viewModel from '@/components/personnelManage/viewModel.vue'
import bindCustomer from '@/components/personnelManage/bindCustomer.vue'
import bindShop from '@/components/bindShop/bindShop.vue'
export default {
	name: 'personnelManage',
	components: {
		Search, viewModel, bindCustomer, bindShop
	},
	data () {
		return {
			customerDialog: false,
			customerBoxDialog: false,
			showCreatBtn: false,
			picList: [],
			staffName: '',
			staffid: '',
			isShowPic: false,
			showBatchSetting: false,
			AuthorityList: {
				'01_0004_0001_00': false,
				'01_0004_0002_00': false,
				'01_0004_0003_00': false,
				'01_0004_0004_00': false,
				'01_0004_0005_00': false,
				'01_0004_0006_00': false,
				'01_0004_0007_00': false,
				'01_0004_0008_00': false
			},
			status: 0,
			alertList: [],
			name: '',
			phone: '',
			sIds: [],
			usertype: -1,
			addModal: false,
			alertModal: false,
			isAdd: false,
			modifyData: {},
			tableData: [],
			tableData1: [],
			tableHeight: '100%',
			total: 0,
			page: {
				number: 1,
				size: 20
			},
			shopid: -1,
			staffNum: 0,
			type: 0,
			showSubordinate: false,
			userName: '',
			selectData: [],
			subscriptionSendFlag: '',
			tableSelectUtils: this.$fxUtils.tableSelectUtils({
				key: 'staffid',
				selectHandler: this.tableSelectUtilsHandler
			}),
			multiWord: '0',
			relAllShopFlag: 1,
			shopDialog: false,
			chooseShop: [],
			shopText: '',
			relAllCusFlag: 1,
			cusDialog: false,
			chooseCus: [],
			cusText: '',
			chooseData: [],
			allData: [],
			openType: 0
		}
	},
	created () {
		this.getOrganInfo()
		this.tableReload()
		this.getAuthority('01_0004_0000_00')
	},
	computed: {
		ids () {
			return this.tableSelectUtils.getSelectRows()
		}
	},
	methods: {
		getOrganInfo () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/get/organInfo`
			}).then(res => {
				console.log(res)
				window.sessionStorage.setItem('syscode', res.syscode)
			})
		},
		multiSet () {
			if (this.ids.length === 0) {
				this.$message.warning('请至少勾选一个员工！')
				return false
			}
			this.multiWord = '0'
			this.relAllShopFlag = 1
			this.chooseShop = []
			this.shopText = ''
			this.relAllCusFlag = 1
			this.chooseData = []
			this.chooseCus = []
			this.cusText = ''
			this.showBatchSetting = true
		},
		saveBatchCus (num) {
			if (this.chooseCus.length === 0 && this.relAllCusFlag === 0) {
				this.$message.error('员工必须关联客户信息！')
				return false
			}
			let list = []
			if (num === 1) {
				list = [this.staffid]
			} else if (num === 2) {
				this.ids.forEach(item => {
					list.push(item.staffid)
				})
			}
			let params = {
				relAllCustomerFlag: this.relAllCusFlag,
				category: this.chooseCus,
				userIds: list
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/businessStaff/saveUserManageredCustomer`,
				data: params
			}).then(res => {
				if (res.result) {
					if (num === 1) {
						this.customerBoxDialog = false
					} else if (num === 2) {
						this.showBatchSetting = false
					}
					this.tableSelectUtils.clear()
					this.tableReload()
				} else {
					this.$message.error(res.msg)
				}
			})
			console.log(params)
		},
		saveBatchShop () {
			if (this.chooseShop.length === 0 && this.relAllShopFlag === 0) {
				this.$message.error('员工必须关联门店信息！')
				return false
			}
			let list = []
			this.ids.forEach(item => {
				list.push(item.staffid)
			})
			let params = {
				relAllShopFlag: this.relAllShopFlag,
				shopIds: this.chooseShop,
				userIds: list.join(',')
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/staff/saveRelUserShop`,
				data: params
			}).then(res => {
				if (res.result) {
					this.showBatchSetting = false
					this.tableReload()
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		bindShopClick () {
			this.shopDialog = true
		},
		reloadShop (data) {
			this.chooseShop = data.chooseData
			this.shopText = data.shopText
			this.shopDialog = false
		},
		reloadCustomer (data) {
			this.chooseCus = data.chooseData
			this.allData = data.allData
			console.log(this.chooseCus)
			this.initCusData2()
		},
		tableSelectUtilsHandler (row) {
			return {
				staffid: row.staffid,
				staffName: row.staffName
			}
		},
		closeCustomer () {
			this.customerDialog = false
			// this.tableReload()
		},
		getUnBindList () {
			let params = {
				userName: this.userName,
				staffId: this.staffid
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/businessStaff/findUnManagerUserInfo`,
				data: params
			}).then(res => {
				if (res.result) {
					this.tableData1 = res.data.userInfo
					this.$refs.table1.doLayout()
					this.staffNum = res.data.canManagerUserCount
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		getBindList () {
			let params = {
				userName: this.userName,
				staffId: this.staffid
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/businessStaff/findManageredUserInfo`,
				data: params
			}).then(res => {
				if (res.result) {
					this.tableData1 = res.data.userInfo
					this.$refs.table1.doLayout()
					this.staffNum = res.data.canManagerUserCount
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		customerBoxClick (data) {
			console.log(data)
			this.staffid = data.staffid
			this.relAllCusFlag = data.relAllCustomerFlag
			this.chooseCus = []
			// this.cusText = ''
			this.getChoose()
			this.customerBoxDialog = true
		},
		getChoose () {
			let params = {
				staffId: this.staffid
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/businessStaff/findUserManageredCustomerInfo`,
				data: params
			}).then(res => {
				if (res.result) {
					if (res.data.length !== 0) {
						this.chooseData = res.data
						this.chooseCus = this.chooseData[0].category
						this.initCusData()
					} else {
						this.chooseData = []
						this.cusText = ''
					}
					console.log(this.chooseData)
				}
			})
		},
		checkCusNum (data) {
			let num = 0
			data.forEach(item => {
				if (item.id !== '-1') {
					num++
				}
			})
			return num
		},
		mapSetId (arr, map) {
			arr.forEach(item => {
				if (map.has(item.id)) {
					map.set(item.id, [...map.get(item.id), item])
				} else {
					map.set(item.id, [item])
				}
			})
		},
		interceptArray (arr, map) {
			Array.from(map).forEach(item => {
				if (item[1].length > 1) {
					item[1].length = 1
				}
				arr.push(item[1][0])
			})
		},
		filterTransFer (arr) {
			let a = arr.filter(item => item.categoryFlag === 1)
			let b = arr.filter(item => item.categoryFlag === 0)
			let m = new Map()
			let n = new Map()
			let resultArr = []
			let resultArr2 = []
			this.mapSetId(a, m)
			this.mapSetId(b, n)
			this.interceptArray(resultArr, m)
			this.interceptArray(resultArr2, n)
			resultArr.forEach((item, index) => {
				resultArr2.forEach((item2, index2) => {
					if (item2.id === item.id) {
						resultArr2.splice(index2)
					}
				})
			})
			return [...resultArr, ...resultArr2]
		},
		initCusData () {
			let textArr = []
			let chooseData = []
			this.chooseData.forEach(item => {
				item.category.forEach(item2 => {
					chooseData.push(item2)
				})
			})
			let list = this.filterTransFer(chooseData)
			list.forEach(item => {
				let itemText = ''
				if (item.categoryFlag === 1) {
					itemText = item.name + '（整类）'
				} else {
					itemText = item.name + '（' + this.checkCusNum(item.cus) + '个）'
				}
				textArr.push(itemText)
			})
			this.cusText = textArr.join('，')
		},
		initCusData2 () {
			let textArr = []
			let list = this.filterTransFer(this.allData)
			list.forEach(item => {
				let itemText = ''
				if (item.categoryFlag === 1) {
					itemText = item.name + '（整类）'
				} else {
					itemText = item.name + '（' + this.checkCusNum(item.cus) + '个）'
				}
				textArr.push(itemText)
			})
			this.cusText = textArr.join('，')
		},
		initShopData (type) {
			let textArr = []
			let idArr = []
			let list = this.chooseData
			list.forEach(item => {
				item.cus.forEach(shop => {
					if (shop.id !== '-1') {
						textArr.push(shop.name)
						idArr.push(shop.id)
					}
				})
			})
			if (type === 'name') {
				let text = textArr.join('，')
				return text
			}
			if (type === 'id') {
				return idArr
			}
		},
		customerClick (type) {
			this.openType = type
			// this.staffName = data.staffName
			// this.staffid = data.staffid
			this.customerDialog = true
		},
		bindClick () {
			if (this.selectData.length === 0) {
				this.$message.error('请勾选员工！')
				return false
			}
			let ids = []
			this.selectData.forEach(item => {
				ids.push(item.userId)
			})
			let params = {
				directlyStaffManagerIds: ids,
				staffId: this.staffid
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/businessStaff/bindLeaderForUser`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success('绑定成功！')
					this.reloadTableData()
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		unBindClick () {
			if (this.selectData.length === 0) {
				this.$message.error('请勾选员工！')
				return false
			}
			let ids = []
			this.selectData.forEach(item => {
				ids.push(item.directlyStaffManagerId)
			})
			let params = {
				directlyStaffManagerIds: ids,
				staffId: this.staffid
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/businessStaff/unBindLeaderForUser`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success('解绑成功！')
					this.reloadTableData()
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		reloadTableData () {
			if (this.type === 1) {
				this.getBindList()
			} else {
				this.getUnBindList()
			}
		},
		closeClick () {
			this.showSubordinate = false
			this.tableReload()
		},
		handleSelectionChange1 (data) {
			this.selectData = data
			// console.log(data)
		},
		// 多选状态禁用
		selectable1 (row, index) {
			if (this.type === 0) {
				if (row.leaderFlag === 1) {
					return false
				} else {
					return true
				}
			} else {
				if (row.directlyFlag === 1) {
					return true
				} else {
					return false
				}
			}
		},
		subordinateClick (data) {
			this.staffName = data.staffName
			this.staffid = data.staffid
			this.showSubordinate = true
			this.userName = ''
			this.type = 1
			this.getBindList()
		},
		reloadPicClick () {
			let params = {
				userId: this.staffid
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/customer/createInvitationCode`,
				data: params
			}).then(res => {
				if (res.result) {
					this.picList = res.data
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		picCancel () {
			this.isShowPic = false
		},
		rowClick (row, column, event) {
			this.modifyClick(row)
		},
		alertCancel () {
			this.alertModal = false
		},
		selectable (row, index) {
			if (row.isAdmin === 1) {
				return false
			} else {
				return true
			}
		},
		getAuthority (id) {
			let params = {
				pId: id
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
				}
			})
		},
		enabled () {
			if (this.ids.length === 0) {
				this.$message.error('请先选择员工！')
			} else {
				let list = []
				this.ids.forEach(item => {
					list.push(item.staffid)
				})
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlIV}/account/staff/status/enabled`,
					data: list
				}).then(res => {
					if (res.result === true) {
						this.tableSelectUtils.clear()
						this.$message.success('启用成功')
						this.tableReload()
					} else {
						this.$message.error(res.msg)
					}
				})
			}
		},
		disabled () {
			if (this.ids.length === 0) {
				this.$message.error('请先选择员工！')
			} else {
				let list = []
				this.ids.forEach(item => {
					list.push(item.staffid)
				})
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlIV}/account/staff/status/disabled`,
					data: list
				}).then(res => {
					if (res.result === true) {
						this.tableSelectUtils.clear()
						this.$message.success('停用成功')
						this.tableReload()
					} else {
						this.$message.error(res.msg)
					}
				})
			}
		},
		deleteList () {
			if (this.ids.length === 0) {
				this.$message.error('请先选择员工！')
			} else {
				this.$confirm('确认删除该员工', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					closeOnClickModal: false
				}).then(() => {
					let list = []
					this.ids.forEach(item => {
						list.push(item.staffid)
					})
					const staffNames = this.ids.map(item => item.staffName).join(',')
					const logger = this.$fxLogger.createInfo('seller.employee-manage.delete', { name: staffNames })
					this.$store.dispatch('requestPost', {
						url: `${this.$fxBaseApi.urlIV}/account/staff/remove`,
						data: list,
						logger
					}).then(res => {
						if (res.result === true) {
							this.tableSelectUtils.clear()
							this.$message.success('删除成功')
							this.tableReload()
						} else {
							// 杰哥说：只要是false就抛alert异常
							this.alertList = res.data
							this.alertModal = true
						}
					})
				})
			}
		},
		getTableDataHandle (data) {
			this.tableSelectUtils.clear()
			this.tableData = data.staffs
			this.total = data.count
		},
		getParamsData (data) {
			// console.log(data)
			this.page.number = data.page
			this.page.size = data.size
			this.status = data.staffDisabled
			this.usertype = data.usertype
			this.name = data.staffName
			this.phone = data.tel
			this.sIds = data.sIds
			this.shopid = data.shopid
			this.subscriptionSendFlag = data.subscriptionSendFlag
		},
		showModal (data) {
			this.addModal = data
			this.isAdd = data
			this.tableReload()
		},
		modifyClick (data) {
			// console.log(data)
			this.modifyData = []
			this.modifyData = data
			// console.log(data)
			this.addModal = true
			// this.isAdd = false
			window.sessionStorage.setItem('isAdd', JSON.stringify(false))
			this.$nextTick(() => {
				this.isAdd = true
			})
		},
		handleSelectionChange (data) {
			this.tableSelectUtils.selectToggle(this.tableData, data)
		},
		addClick () {
			this.modifyData = null
			this.addModal = true
			this.isAdd = true
			window.sessionStorage.setItem('isAdd', JSON.stringify(true))
		},
		deleteClick (data) {
			this.$confirm('确认删除该员工和相关提成方案？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
				closeOnClickModal: false
			}).then(() => {
				let arr = [data.staffid]
				let params = arr
				const logger = this.$fxLogger.createInfo('seller.employee-manage.delete', { name: data.staffName })
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlIV}/account/staff/remove`,
					data: params,
					logger
				}).then(res => {
					if (res.result === true) {
						this.$message.success('删除成功')
						this.tableReload()
					} else {
						// 杰哥说：只要是false就抛alert异常
						this.alertList = res.data
						this.alertModal = true
					}
				})
			}).catch(() => {})
		},
		// cancelClick () {
		// 	this.addModal = false
		// 	this.isAdd = false
		// 	this.$refs.addModal.resetForm('ruleForm')
		// },
		tableReload () {
			let params = {
				usertype: this.usertype,
				staffName: this.name,
				staffDisabled: this.status,
				tel: this.phone,
				sIds: this.sIds,
				page: this.page.number,
				size: this.page.size,
				shopid: this.shopid,
				subscriptionSendFlag: this.subscriptionSendFlag
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/staff/list`,
				data: params
			}).then(res => {
				if (res.result === true) {
					this.$nextTick(() => {
						this.tableData = res.data.staffs
						this.tableSelectUtils.setTableDefaultSelect(this.tableData, this.$refs.table)
						this.total = res.data.count
					})
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		handleSizeChange (val) {
			this.page.size = val
			this.tableReload()
		},
		handleCurrentChange (val) {
			this.page.number = val
			this.tableReload()
		}
	}
}
</script>
<style lang="stylus" scoped>

.personnelManage-body{
    display: flex;
    min-width :1000px;
    width :100%;
	flex-direction: column;
    height :100%;
    overflow-y :auto;
    padding-bottom :50px;
    border-radius :0px 0px 10px 10px;
	.type-box{
		display: flex;
		flex-direction: row;
		width: 100%;
		height: 30px;
		align-items: center
	}
	.input-box {
		display flex
		width: 400px;
		align-items: center;
		height: 40px;
		span {
			margin-right: 10px
		}
		.name-input {
			flex: 1;
			margin-right :10px
		}
	}
	.main-table-box {
		flex: 1
		padding-bottom 10px
		overflow-y: auto;
	}
    .btn-box1{
        width :90%;
        padding :15px;
		padding-left: 0;
        text-align :left
    }
	.alert-span{
		line-height :40px;
		height :40px;
		text-align :left
		padding-left :10px
	}
	.pic-box{
		display:flex;
		flex-direction :row;
		flex-wrap:wrap;
		width :100%;
		max-height:320px;
		overflow-y:auto;
		.pic-container{
			box-sizing:border-box;
			border:1px solid #eee;
			text-align :center;
			width :120px;
			height:150px;
			margin:0px 10px 10px 10px;
			.pic-div{
				margin-left:20px;
				width:80px;
				height:80px
				margin-top:5px;
			}
			.pic-info{
				box-sizing:border-box;
				padding:0px 5px;
				height:30px;
				line-height :30px;
				font-size:12px;
				width:100%;
				text-align:center;
				overflow: hidden;
				text-overflow:ellipsis;
				white-space: nowrap;
			}
		}
	}
	.text-box{
		margin-top:5px;
		padding-left:10px;
		text-align:left;
		color:red;
		font-size:12px;
	}
	.batchSetBox {
		padding-bottom: 1px;
		span {
			display: inline-block;
			width: 90px;
			text-align: right;
		}
		.input-box {
			margin: 10px 20px;
		}
		.title-btn-box{
			padding:10px;
			box-sizing:border-box;
			text-align:center
			.btn{
				width:130px;
			}
		}
	}
	.dialog-title {
		text-align: left
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}
}

</style>
<style lang="stylus">
.personnelManage-body {
	.cell{
		padding :0px !important
	}
	.detail-dialog-title {
		.el-dialog__header {
			display: none
		}
		.el-dialog__title {
			padding-left 10px;
			border: none !important;
		}
	}
	.showPicDialog{
		.el-dialog__header {
			border-bottom:1px solid #eee;
			padding: 20px 0px 10px;
			text-align: left;
		}
	}
	.customerDialog{
		.el-dialog__header {
			margin :0px 20px;
			padding :10px 0px;
			border-bottom:1px solid #eee;
			text-align: left;
		}
		.el-dialog__body{
			padding: 10px 20px 10px 20px;
		}
		.name-input .el-input-group__append{
			background-color:var(--fx-primary-color);
			color:#FFFFFF
		}
	}
	.subordinateDialog{
		.el-dialog__body{
			padding :0px 20px;
		}
		.el-dialog__header {
			display :none
		}
		.blue-line{
			height :20px;
			width: 5px;
			background-color :var(--fx-primary-color);
			margin-right :10px;
		}
		.title{
			font-size:16px;
			justify-content: space-between;
			font-weight: bold;
			display :flex;
			flex-direction :row;
			border-bottom:1px solid #eee;
			padding: 20px 0px 10px;
			text-align: left;
			margin-bottom :5px;
			.close{
				cursor: pointer;
				width: 20px;
				height: 20px;
				display :flex;
				align-items :center;
				justify-content :center;
				color :white;
				border-radius: 50%;
				background-color: #f00;
				line-height: 21px;
				font-weight: bold;
			}
		}
	}
	.alert-dialog{
		.el-dialog__title {
			padding-left 10px;
			border: none !important;
			float : left !important;
		}
		.el-dialog__body{
			padding:20px 20px 20px 20px
		}
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: #FFFFFF !important;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:black !important;
			}
		}
	}
	.el-dialog__body{
		padding:10px 20px 0px 20px
	}


}
</style>
